import React from 'react';
import AnnuityFIAValuesSection from './AnnuityFIAValuesSection';
import AnnuityValuesSection from './AnnuityValuesSection';
import HealthValuesSection from './HealthValuesSection';
import LifeTermValuesSection from './LifeTermValuesSection';
import LifeValuesSection from './LifeValuesSection';
import MedSupValuesSection from './MedSupValuesSection';
import SuppContractValuesSection from './SuppContractValuesSection';

const AccountValuesSection = ({ model, portalSettings }) => {

    const insType = model.policyInfo.insuranceType.toLowerCase();
    const inForce = model.policyInfo.inForce;
    const isHealth = model.policyInfo.polType.includes('NonMS');
    const isMS = model.policyInfo.polType.includes('MS') && !isHealth;

    if (inForce == false) {
        return (
            <div className="alert-box">
                <div className="alert-message">
                    <h2>This policy is no longer active. </h2>
                </div>
            </div>
        );
    }

    if (
        !model.annuityFIAValues &&
        !model.annuityValues &&
        !model.healthValues &&
        !model.lifeValues &&
        !model.lifeTermValues &&
        !isHealth &&
        !isMS &&
        !model.suppContractValues
    ) {
        return (
            <div className="alert-box">
                <div className="alert-message">
                    Your values are currently being updated. Please check back soon.
                </div>
            </div>    
        );
    }

    let SectionComponent = null;

    switch (insType) {
        case "af": //Annuity
            SectionComponent = <AnnuityValuesSection model={model} portalSettings={portalSettings} />;
            break;
        case "ai": //FIA
            SectionComponent = <AnnuityFIAValuesSection model={model} portalSettings={portalSettings} />;
            break;
        case "hs": //MedSupp
            SectionComponent = <MedSupValuesSection model={model} portalSettings={portalSettings} />;
            break;
        case "spia": //SuppContract
        case "scwlc": //SuppContract
        case "scwolc": //SuppContract
            SectionComponent = <SuppContractValuesSection model={model} portalSettings={portalSettings} />;
            break;
        case "ha":
        case "hc": //Health
        case "hh": //Health
        case "hi": //Health
        case "hx": //Health
            SectionComponent = <HealthValuesSection model={model} portalSettings={portalSettings} />;
            break;
        case "lw": //Life
        case "lt": //LifeTerm
        case "le": //Life Endowed
            SectionComponent = <LifeValuesSection model={model} portalSettings={portalSettings} />;
            break;
    }
    return (
        <>
            {SectionComponent}
        </>
    );
};

export default AccountValuesSection;

